import Device from 'baseStyles/enums/device';
import { useTopWindowSize } from 'hooks/useTopWindowSize';
import React, { useContext, useMemo } from 'react'

export const DeviceTypes = Device.types;
interface IAppMediaProviderState {
    isDesktop: boolean;
    isTablet: boolean;
    isMobile: boolean;
    isMobileSmall: boolean;
    isMobileSmallLandscape: boolean;
    isMobileLandscape: boolean;
    currentDevice: Device.types;
};

const AppMediaProviderContext = React.createContext({} as IAppMediaProviderState);

const AppMediaProvider = ({ children }: any) => {
    const windowSize =  useTopWindowSize();
    const isDesktop = windowSize.width >= Device.breakpoints[Device.types.Desktop].min!;
    const isTablet = windowSize.width >= Device.breakpoints[Device.types.Tablet].min! && windowSize.width <= Device.breakpoints[Device.types.Tablet].max!;
    const isMobile = windowSize.width <= Device.breakpoints[Device.types.Mobile].max!;
    const isMobileSmall = windowSize.width <= Device.breakpoints[Device.types.MobileSmall].max!;
    const isMobileSmallLandscape = windowSize.width <= Device.breakpoints[Device.types.MobileSmall].max! && windowSize.width >= windowSize.height;
    const isMobileLandscape = windowSize.width <= Device.breakpoints[Device.types.Mobile].max! && windowSize.width >= windowSize.height;

    const currentDevice: Device.types = useMemo(() => {
        if (isDesktop) return Device.types.Desktop;
        else if (isTablet) return Device.types.Tablet;
        else if (isMobile) return Device.types.Mobile;
        else if (isMobileLandscape) return Device.types.MobileLandscape
    }, [isDesktop, isTablet, isMobile, isMobileLandscape]);

    const values: IAppMediaProviderState = {
        isDesktop,
        isTablet,
        isMobile,
        isMobileSmall,
        isMobileLandscape,
        isMobileSmallLandscape,
        currentDevice
    };

    return (
        <AppMediaProviderContext.Provider value={values}>
            <div data-width={windowSize.width} data-height={windowSize.height} className={`media-device-${currentDevice}`}>
                {children}
            </div>
        </AppMediaProviderContext.Provider>
    )
}

export const useAppMediaProvider = () => {
    const context = useContext(AppMediaProviderContext);
    if (!context) {
        // throw Error(`Use ${useAppMediaProvider.name} in ${AppMediaProviderContext.displayName}`);
        console.warn(`Use ${useAppMediaProvider.name} in ${AppMediaProviderContext.displayName}`);
    }
    return context;
};

export default AppMediaProvider